import { GlobalStore, GridStore } from '@roc/feature-app-core';
import { makeObservable, observable, action } from 'mobx';
import { ClosingConditionsDashboardService } from '../services/closingConditionsTasks/closingConditionsDashboardService';

export const ClosingConditionTab = {
  MY_CLOSING_CONDITIONS: 'MY_CLOSING_CONDITIONS',
  MY_TEAM_CLOSING_CONDITIONS: 'MY_TEAM_CLOSING_CONDITIONS',
  ALL_CLOSING_CONDITIONS: 'ALL_CLOSING_CONDITIONS',
  POST_CLOSING_CONDITIONS: 'POST_CLOSING_CONDITIONS',
};

export class ClosingConditionsDashboardStore {
  globalStore: GlobalStore;
  closingConditionsDashboardService: ClosingConditionsDashboardService;
  closingConditionsGridStore: GridStore;
  currentTab: string = ClosingConditionTab.MY_CLOSING_CONDITIONS;

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore;
    this.closingConditionsDashboardService = new ClosingConditionsDashboardService();

    this.closingConditionsGridStore = new GridStore(() =>
      this.fetchClosingConditions()
    );

    makeObservable(this, {
      currentTab: observable,
      setCurrentTab: action,
    });
  }

  setCurrentTab(tab: string) {
    this.currentTab = tab;
    this.closingConditionsGridStore.resetAndFetchGridData();
  }

  async fetchClosingConditions() {
    try {
      const response = await this.closingConditionsDashboardService.getClosingConditions(
        this.currentTab,
        this.closingConditionsGridStore.gridData.meta.pageNumber,
        this.closingConditionsGridStore.gridData.meta.pageSize,
        this.closingConditionsGridStore.gridData.meta.sortDir ?? 'ASC',
        this.closingConditionsGridStore.gridData.meta.sortBy ?? 'expectedClosingDate',
        this.closingConditionsGridStore.gridData.meta.filters ?? {},
        this.closingConditionsGridStore.gridData.meta.dropdownFilters ?? {}
      );
      return response;
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error fetching closing conditions.',
      });
    }
  }
}